// extracted by mini-css-extract-plugin
export var dropdown = "_sd-0";
export var imageWrapper = "_sd-3";
export var itemNameContainer = "_sd-1";
export var productImage = "_sd-2";
export var spinnerWrapper = "_sd-4";